import _ from 'lodash';
export const normalizeBase64String = (string) => {
    if (!string) {
        return string;
    }
    const mismatchIndex = string.length % 4;
    if (mismatchIndex !== 0) {
        let stringToAppend = '';
        const numCharactersNeeded = 4 - mismatchIndex;
        for (let i = 0; i < numCharactersNeeded; i++) {
            stringToAppend += '=';
        }
        string += stringToAppend;
    }
    return string;
};
export const encodeBase64URLString = (string) => {
    if (!string) {
        return string;
    }
    return btoa(string)
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
};
export const decodeBase64URLString = (string) => {
    if (!string) {
        return string;
    }
    const replacedString = string.replace(/-/g, '+').replace(/_/g, '/');
    return atob(replacedString);
};
export const encodeUnicodeURLString = (string) => {
    if (!string) {
        return string;
    }
    return btoa(_.unescape(encodeURIComponent(string)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
};
export const decodeUnicodeURLString = (string) => {
    if (!string) {
        return string;
    }
    const replacedString = string.replace(/-/g, '+').replace(/_/g, '/');
    return decodeURIComponent(_.escape(atob(replacedString)));
};
export const generateURIParamsString = (params) => {
    return Object.keys(params)
        .filter(key => params[key] !== undefined || params[key] != null)
        .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
        .join('&');
};
//# sourceMappingURL=base64-utils.js.map